import { createClinicalEncounter } from './api';

export function isEvolutionNoteEncounter(enc) {
  return enc?.encounter_type !== 'intake';
}

function hasEvolutionNoteText(...values) {
  return values.some((v) => String(v || '').trim() !== '');
}

/** Nota con al menos un campo de texto guardado (imprimible). */
export function canPrintEvolutionNote(enc) {
  if (!enc || !isEvolutionNoteEncounter(enc)) return false;
  return hasEvolutionNoteText(
    enc.chief_complaint,
    enc.clinical_notes,
    enc.diagnosis,
    enc.treatment_plan,
  );
}

/** Incluye texto aún no guardado en el formulario abierto. */
export function canPrintEvolutionNoteFromForm(enc, form = {}) {
  if (!enc || !isEvolutionNoteEncounter(enc)) return false;
  return hasEvolutionNoteText(
    form.chief_complaint,
    form.clinical_notes,
    form.diagnosis,
    form.treatment_plan,
    enc.chief_complaint,
    enc.clinical_notes,
    enc.diagnosis,
    enc.treatment_plan,
  );
}

/**
 * Crea una nota de evolución en borrador y navega al formulario.
 * @returns {Promise<boolean>} true si se creó y navegó correctamente
 */
export async function createAndOpenEvolutionNote(recordId, navigate, options = {}) {
  const { appointmentId } = options;
  const payload = {
    encounter_type: 'follow_up',
    status: 'draft',
  };
  if (appointmentId) {
    payload.appointment_id = appointmentId;
  }
  const enc = await createClinicalEncounter(recordId, payload);
  if (!enc?.id) {
    return false;
  }
  navigate(`/admin/expedientes/${recordId}/encuentro/${enc.id}`);
  return true;
}
